/*Application types*/
export const SAML2_APPLICATION = "SAML2_APPLICATION";
export const OIDC_APPLICATION = "OIDC_APPLICATION";
export const OIDC_ENTRA_ID_EAM_APPLICATION = "OIDC_ENTRA_ID_EAM_APPLICATION";
export const WS_FEDERATION_APPLICATION = "WS_FEDERATION_APPLICATION";